import { Component, EventEmitter, Input, Output } from '@angular/core';
import { throwMatDuplicatedDrawerError } from '@angular/material/sidenav';
import { documentExporting } from '@syncfusion/ej2-angular-richtexteditor';
@Component({
	selector: 'app-panel-header',
	templateUrl: './panel-header.component.html',
	styleUrl: './panel-header.component.scss'
})
export class PanelHeaderComponent {

	/** dashboardStartDate */
	@Input() public dashboardStartDate: Date;

	/** dashboardEndDate */
	@Input() public dashboardEndDate: Date;

	/** dashboardStrDuration */
	@Input() public dashboardStrDuration: string;

	/** containingDiv */
	@Input() public containingDiv: HTMLElement;

	/** dashboardFullscreen */
	@Input() public dashboardFullscreen: boolean;

	/** panelFullscreen */
	@Output() public panelFullscreen = new EventEmitter<boolean>();

	/** customRange */
	@Output() public customRange = new EventEmitter<{ start: Date, end: Date } | undefined>();

	/** customTimeRange */
	@Input() public customTimeRange: boolean = false;

	/** startDate */
	public startDate?: Date = undefined;

	/** endDate */
	public endDate?: Date = undefined;

	/** strDuration */
	public strDuration: string = "00:08:00";

	/** numDays */
	@Input() public numDays: number = 1;

	/** DAY */
	public DAY: number = (1 * 24 * 60 * 60 * 1000);

	/** document - to access in html */
	public document = document;

	/** panelData */
	@Input() public panelData: any;

	/** shortMonths */
	private shortMonths: string[] = [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	];

	/**
	 * datePickerChange
	 * @param event event 
	 */
	datePickerChange(event: any) {
		this.customTimeRange = true;
		if (event.startDate && event.endDate) {
			this.startDate = event.startDate;
			this.endDate = new Date(event.endDate.getTime() + (24 * 60 * 60 * 1000)); //including last day
			if (this.startDate && this.endDate) {
				this.numDays = parseFloat(((this.endDate.getTime() - this.startDate.getTime()) / this.DAY).toFixed(2));

				this.emitCustomRange();
			}
		}
	}

	/**
	 * durationChange
	 * @param event event 
	 */
	durationChange(event: any) {
		this.customTimeRange = true;
		this.strDuration = event;

		if (this.strDuration) {
			let parts: any[] = this.strDuration.split(":")
			this.endDate = new Date()
			this.startDate = new Date()
			this.startDate.setDate(this.startDate.getDate() - parts[0]);
			this.startDate.setHours(this.startDate.getHours() - parts[1]);
			this.startDate.setMinutes(this.startDate.getMinutes() - parts[2]);

			this.numDays = parseInt(parts[0]) || parseFloat((parseInt(parts[1]) / 24).toFixed(2));

			this.emitCustomRange();
		}
	}

	/**
	 * resetTimePeriod
	 */
	resetTimePeriod() {
		this.customTimeRange = false;
		this.startDate = undefined;
		this.endDate = undefined;
		this.strDuration = this.dashboardStrDuration;
		this.emitCustomRange(true);
	}

	/**
	 * fullscreenPanel
	 */
	fullscreenPanel() {
		if (this.containingDiv) {
			this.containingDiv.requestFullscreen();
			this.panelFullscreen.emit(true);
		}
	}

	/**
	 * exitFullscreen
	 */
	exitFullscreen() {
		if (document.fullscreenElement) {
			document.exitFullscreen();
		}
	}

	/**
	 * emitCustomRange
	 * @param cancel cancel  
	 */
	emitCustomRange(cancel: boolean = false) {
		if (!cancel) {
			if (this.startDate && this.endDate) {
				this.customRange.emit({ start: this.startDate, end: this.endDate });
			}
		} else {
			this.customRange.emit(undefined);
		}
	}

	/**
	 * getCustomTimeRangeText
	 * @returns 
	 */
	getCustomTimeRangeText(): string {
		let result: string = "";
		if (this.panelData) {
			if (this.panelData.duration) {
				result = `${this.numDays <= 1 ? (this.numDays * 24).toFixed(0) : this.numDays} ${this.numDays <= 1 ? "Hours" : "Days"}`;
			} 
			else if (this.panelData.range) {
				result = `${this.getShortDate(new Date(this.panelData.range[0]))} - ${this.getShortDate(new Date(this.panelData.range[1]))}`;
			}
			else if (this.panelData.preset) {
				result = this.panelData.preset;
			}
			else {				
				result = `${this.numDays <= 1 ? (this.numDays * 24).toFixed(0) : this.numDays} ${this.numDays <= 1 ? "Hours" : "Days"}`;
			}
		}
		return result;
	}

	/** getShortDate */
	getShortDate(date: Date): string {
		let result: string = "";
		result += date.getDate();
		result +=
			" " +
			this.shortMonths[date.getMonth()] +
			" " +
			date.getHours().toString().padStart(2, "0") +
			":" +
			date.getMinutes().toString().padStart(2, "0");

		return result;
	}
}
